import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { BsyUtils } from "../../../utils/Utils";
import BsyAlertMenu from "../../BsyAlertMenu";
import FlowSwitchMenu from "../BsyDashboardFlowPaneV2/FlowSwitchMenu";

import "./index.css";
import BsySLoading from "../../BsySLoading";
import BsySearchInput from "../../BsySearchInput";
import BsyFilterPane from "../../BsyFilterPane";
import BsyMsgBubble from "../../BsyMsgBubble";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsyFormPane from "../../BsyFormPane";
import {
  _submitSign,
  _switchBackNode,
  _switchSubmit,
  _switchTransferChargers,
  generateQuickBtn,
} from "../BsyDashboardApp/flowUtils";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { createTooltip } from "../../../utils/createTooltip";
import BsySystemLeftMenu from "../../BsySystemLeftMenu";
import BsySystemRightMenu from "../../BsySystemRightMenu";
import { setPageTitle } from "../../../utils/setPageTitle";
import { dayjsUtils } from "../../../utils/dayjsUtils";
import { getAfterSuffix } from "../../../utils/getAfterSuffix";

class BsyDashboardFlowCenter extends Component {
  static defaultProps = {
    type: "",
    mode: "externalFlow",
    corpId: "",
    isDock: false,
    todocount: 0,
    dockcount: 0,
    dockCorp: [],
    corp_count: {},
    default_corp: "",
  };

  constructor(props) {
    super(props);
    this.body = React.createRef();
    this.menu = React.createRef();
    this.flowlistRef = React.createRef();
    let dd = localStorage.getItem("BsyDashboardFlowCenterSort");
    let sort = dd ? dd : -1;

    this.state = {
      type: props.type, //this.props.match.params.id,
      title: this.FlowMenuData[this.FlowMenuMap[props.type]].text, //this.FlowMenuData[this.FlowMenuMap[this.props.match.params.id]].text,
      sort: Number(sort),
      filterType: props.filterType || props.type === "cc" ? "isread0" : "all",
      items: [],
      filter: [],
      limit: 20,
      urgecount: 0,
      aboutcount: 0,
      timeoutcount: 0,
      dockCorp: props.dockCorp,
      mode: props.mode,
      corpId: props.corpId,
      isDock: props.isDock,
      todocount: props.todocount,
      dockcount: props.dockcount,
      corp_count: props.corp_count,
      default_corp: props.default_corp,
      todoCount: 0,
      page: 0,
      keyword: null,
      success: false,
      isMore: false,
      isMoreLoading: false,
      flowActive: "internalFlow",
      seachSwitch: !window.hasOwnProperty("flow_search_switch") ? true : window.flow_search_switch,
      query_cc_unread: false,
      ...(props.location.state ? props.location.state : {}),
    };
    this.elementRef = React.createRef();
    this.nameMap = {};
    this.todoNum = 0;
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
    // 清理全局变量
    window.FX.STATIC.APPID = null;
    window.FX.STATIC.ENTRYID = null;
    window.FX.STATIC.appId = null;
    window.FX.STATIC.entryId = null;
  }

  componentWillUnmount() {
    this.hideTooltip();
  }

  FlowMenuMap = {
    todo: 0,
    cc: 1,
    transactors: 2,
    create: 3,
    launch: 4,
  };
  FlowMenuData = [
    {
      id: "todo",
      text: React.language("flow.todo"),
      type: "flow",
    },
    {
      id: "cc",
      text: React.language("flow.my.cc"),
      type: "flow",
    },
    {
      id: "transactors",
      text: React.language("flow.my.transactors"),
      type: "flow",
    },
    {
      id: "create",
      text: React.language("flow.visit.create"),
      type: "flow",
    },
    {
      id: "launch",
      text: React.language("flow.create"),
      type: "flow",
    },
  ];

  flowstatuse = { todo: !1, create: !1, part: !1 };

  cleanFilterSet = () => {
    this.filter = null;
    this.appId = null;
    this.entryId = null;
  };

  switchFlowMenu = (val) => {
    //切换了待办 抄送，我发起的
    if (val.id === this.state.type) {
      return;
    }

    this.props.history.push(`/team/${val.id}`, {
      filterType: val.id === "cc" ? "isread0" : "all",
    });
    return;
    this.setState(
      {
        isLoading: true,
        title: val.text,
        type: val.id,
        page: 0,
        items: [],
        filterType: val.id === "cc" ? "isread0" : "all",
        urgecount: 0,
        filterCount: undefined,
        aboutcount: 0,
        keyword: "",
        timeoutcount: 0,
        isMore: false,
        success: false,
      },
      () => {
        if (val.id !== "launch") {
          this.cleanFilterSet();
          this.getFilterCache();
          this.setState(
            {
              filter: this.filter || [],
            },
            () => {
              this.loadTodoCount();
              this.loadFilterCount();
              if (val.id === "cc") {
                this.queryCcUnread();
              }
              this.loadData(null, false);
            }
          );
        } else {
          this.loadFlowStart();
        }
      }
    );
  };

  queryCcUnread = () => {
    const { mode, corpId } = this.state;
    React.axios("/data/query_cc_unread", {
      mode: mode,
      corpId: corpId,
    })
      .then((res) => {
        if (res.data) {
          this.setState({
            filterType:
              this.state.filterType ||
              (this.state.type === "cc" ? "isread0" : "all"),
            query_cc_unread: res.data.exist_cc_unread ? true : false,
            todoCount: res.data.todo_count,
          });
        }
      })
      .catch(() => { });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.type !== this.props.type) {
      window.FX.STATIC.APPID = nextProps.type;
      let dd = localStorage.getItem("BsyDashboardFlowCenterSort");
      let sort = dd ? dd : -1;
      this.setState(
        {
          title: this.FlowMenuData[this.FlowMenuMap[nextProps.type]].text, //nextProps.location.state.title,
          type: nextProps.type,
          filterType: nextProps.type === "cc" ? "isread0" : "all",
          page: 0,
          isMore: false,
          sort: Number(sort),
          items: [],
          isLoading: true,
        },
        () => {
          // if (nextProps.type !== "launch") this.loadData(null, false);
          // else this.loadFlowStart();
          if (nextProps.type !== "launch") {
            this.cleanFilterSet();
            this.getFilterCache();
            this.setState(
              {
                filter: this.filter || [],
              },
              () => {
                this.loadTodoCount();
                this.loadFilterCount();
                if (nextProps.type === "cc") {
                  this.queryCcUnread();
                }
                this.loadData(null, false);
              }
            );
          } else {
            this.loadFlowStart();
          }
        }
      );
    }
  }

  loadFlowStart = () => {
    const { mode, corpId } = this.state;
    React.axios("/dashboard/flow_start", {
      mode: mode,
      corpId: corpId,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let items = [];
          BsyUtils.forEach(res.data.appEntryMap, (i) => {
            var dj = {
              ...res.data.appMap[i],
              data: [...res.data.appEntryMap[i]],
            };
            items.push(dj);
          });
          this.setState({
            isLoading: false,
            items: items,
            success: true,
          });
        });
      })
      .catch((res) => {
        console.error(res);
        this.setState({
          isLoading: false,
        });
      });
  };

  cleanFilter = () => {
    let dft = this.state.filter.filter((ev) => {
      if (!ev) {
        return false;
      }

      if (
        [
          "urgeTime",
          "flowExpireTime",
          "startAction",
          "lastAction",
          "isread",
          "queryState",
        ].includes(ev.field)
      ) {
        return false;
      }
      return true;
    });
    return dft;
  };

  todo = async (cb) => {
    const resdata = await React.axios("/dashboard/app_group/list");

    const res = await React.axios("/dashboard/flow_todo_count", {});

    this.setState({
      todocount: res.data.count,
      loadSuccess: res.data.count === 0 ? true : false,
      countLoading: false,
      dockcount: res.data.dock_count,
      corp_count: res.data.corp_count,
      default_corp: res.data.default_corp,
      corpId: res.data.default_corp,
      dockCorp: resdata.data.dock_corps,
    });
    cb && cb();
  };

  initData = () => {
    const { type, isDock } = this.state;
    this.setState(
      {
        isLoading: true,
        mode: isDock ? "externalFlow" : "internalFlow",
      },
      () => {
        if (type !== "launch") {
          this.cleanFilterSet();
          this.getFilterCache();
          this.setState(
            {
              filter: this.filter || [],
            },
            () => {
              this.loadTodoCount();
              if (type === "cc") this.loadFilterCount();
              this.loadData(null, false, this.props.filterType);
            }
          );
        } else this.loadFlowStart();
        this.loadTodoCount();
        this.loadSeachSwitch();
        this.queryCcUnread();
      }
    );
  };

  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this.setState({
      isLoading: true,
    });
    if (!this.props.location.state || !this.props.location.state.type) {
      this.todo(() => {
        this.initData();
      });
    } else {
      this.initData();
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.match.path !== prevProps.match.path) {
  //     console.log(`由${this.props.match.path}变为${prevProps.match.path}`);

  //     this.switchFlowMenu({
  //       id: prevProps.match.path.split
  //     })

  //   }
  // }

  loadSeachSwitch = () => {
    if (!window.hasOwnProperty("flow_search_switch")) {
      React.axios("/data/flow_search_switch", {})
        .then((res) => {
          if (res.data) {
            window.flow_search_switch = res.data.flow_search_switch;
            this.setState({
              seachSwitch: res.data.flow_search_switch == 0 ? false : true,
            });
          }
        })
        .catch(() => { });
    }
  };

  setCCItemUnreadStyle = (data) => {
    if (this.state.type === "cc") {
      if (!data.hasOwnProperty("unread")) {
        return " cc-read ";
      }
      if (!data.unread) {
        return " cc-read ";
      }
    }
    return "";
  };

  loadData = (op, hascount) => {
    const {
      type,
      sort,
      items,
      page,
      limit,
      filterType,
      keyword,
      mode,
      corpId,
    } = this.state;

    let dft = this.cleanFilter();

    switch (filterType) {
      case "urge": {
        dft = [
          ...dft,
          {
            field: "urgeTime",
            hasEmpty: false,
            method: "not_empty",
            type: "urgeTime",
            value: null,
          },
        ];
        break;
      }
      case "flowExpireTime": {
        let d = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), "yyyy-MM-dd HH:mm:ss");
        let now = dayjsUtils.timeToTZ(new Date());
        now.setDate(now.getDate() + 1);
        let last = BsyUtils.date2Str(now, "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "range",
            type: "datetime",
            value: [d, last],
          },
        ];
        break;
      }
      case "timeout": {
        let d = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "lt",
            type: "datetime",
            value: [d],
          },
        ];
        break;
      }

      case "startAction": {
        dft = [
          ...dft,
          {
            field: "startAction",
            hasEmpty: false,
            method: "eq",
            type: "startAction",
            value: ["back"],
          },
        ];
        break;
      }
      case "lastAction": {
        dft = [
          ...dft,
          {
            field: "lastAction",
            hasEmpty: false,
            method: "eq",
            type: "lastAction",
            value: ["save"],
          },
        ];
        break;
      }
      case "isread1": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: true,
            method: "eq",
            value: [1],
          },
        ];
        break;
      }
      case "isread0": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "inProcess": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "done": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "in",
            value: [1, 2],
          },
        ];
        break;
      }
      default: {
        break;
      }
    }

    let ask = {
      appId: hascount ? undefined : this.appId ? this.appId : type,
      entryId: hascount ? undefined : this.entryId ? this.entryId : undefined,
      formId: hascount ? undefined : this.entryId ? this.entryId : undefined,
      ignoreAppId: hascount ? true : this.appId ? undefined : true,
      hascount: hascount ? hascount : false,
      limit: limit,
      mode: mode,
      corpId: corpId,
      skip: page * limit,
      sort: { updateTime: sort },
      keyword: hascount ? undefined : keyword ? keyword : undefined,
      type: type,
      filter: hascount
        ? undefined
        : BsyUtils.isObjectEmpty(dft)
          ? undefined
          : {
            cond: [...dft],
            rel: "and",
          },
    };
    let url = "/dashboard/flow_todo";
    if (!hascount && this.appId) {
      url = `/dashboard/app/${this.appId}/workflow/query_data`;
    }
    if (op === "more") {
      this.setState({
        isMoreLoading: true,
      });
    }
    React.axios(url, ask)
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          if (!hascount) {
            let isMore = false;
            if (res.data.data.length >= limit) {
              isMore = true;
            }

            let itmebas = [];
            if (op === "more") {
              itmebas = [...items, ...res.data.data];
            } else {
              itmebas = [...res.data.data];
            }
            this.nameMap = { ...this.nameMap, ...res.data.nameMap };
            this.avatarMap = { ...this.avatarMap, ...res.data.avatarMap };
            this.setState({
              // filterType: filterType,
              flowCount: op === "more" ? this.state.flowCount : 0,
              items: itmebas,
              isMore: isMore,
              isMoreLoading: false,
              success: true,
              isLoading: false,
            });
            if (op !== "more") this.loadData(null, true); //请求总数
          } else {
            this.setState({
              flowCount: res.data.count,
              success: true,
              isLoading: false,
              isMoreLoading: false,
            });
          }
        });
      })
      .catch((res) => {
        console.error(res);
        this.setState({
          isLoading: false,
          isMoreLoading: false,
        });
      });
  };

  _toDeptUser = (a) => {
    const { nameMap } = this;
    let str = "";

    if (a && a.hasOwnProperty("nickname")) {
      str = a ? a.nickname : "";
    } else {
      str = BsyUtils._toDeptUser(nameMap[a]);
    }
    return str;
  };

  _formatData = (a) => {
    var b = this;
    if (BsyUtils.isEmpty(a.value)) return "";
    switch (a.type) {
      case "address":
      case "location":
        return BsyUtils.address2Str(a.value, "pcda");
      case "datetime":
        return BsyUtils.date2Str(dayjsUtils.timeToTZ(a.value), a.format);
      case "number":
        const res = BsyUtils.numberFormatValue(a.value, a);
        const afterSuffixVal = getAfterSuffix(a.afterSuffix)
        if (afterSuffixVal && res.text && !res.text.includes("%")) {
          res.text = res.text + ' ' + afterSuffixVal;
        }
        return res.text;
      case "user":
      case "dept":
        return this._toDeptUser(a.value);
      case "usergroup":
      case "deptgroup":
        var c = [];
        BsyUtils.forEach(a.value, function (a, d) {
          c.push(b._toDeptUser(d));
        });
        return c.join(",");
      default:
        return a.value;
    }
  };

  loadTodoCount = () => {
    const { corpId, mode } = this.state;
    let dd = localStorage.getItem("BsyDashboardFlowCenterSort");
    let sort = dd ? dd : -1;
    let abb = {
      appId: this.state.type,
      hascount: true,
      limit: 20,
      mode: mode,
      corpId: corpId,
      skip: 0,
      sort: { updateTime: Number(sort) },
      type: this.state.type,
    };

    let url = "/dashboard/flow_todo";

    switch (this.state.type) {
      case "launch":
      case "todo": {
        React.axios(url, {
          ...abb,
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
          });
        });
        break;
      }
      case "cc": {
        React.axios(`/dashboard/flow_todo`, {
          ...abb,
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
          });
        });
        break;
      }
      default:
        React.axios(`/dashboard/flow_todo`, {
          ...abb,
        }).then((res0) => {
          this.setState({
            allcount: res0.data.count,
          });
        });
    }
  };

  loadFilterCount = () => {
    const { type, filterType, keyword, mode, corpId } = this.state;

    if (filterType !== "all") {
      return;
    }

    let dft = this.cleanFilter();

    switch (filterType) {
      case "urge": {
        dft = [
          ...dft,
          {
            field: "urgeTime",
            hasEmpty: false,
            method: "not_empty",
            type: "urgeTime",
            value: null,
          },
        ];
        break;
      }
      case "flowExpireTime": {
        let d = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), "yyyy-MM-dd HH:mm:ss");
        let now = dayjsUtils.timeToTZ(new Date());
        now.setDate(now.getDate() + 1);
        let last = BsyUtils.date2Str(now, "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "range",
            type: "datetime",
            value: [d, last],
          },
        ];
        break;
      }
      case "timeout": {
        let d = BsyUtils.date2Str(dayjsUtils.timeToTZ(new Date()), "yyyy-MM-dd HH:mm:ss");
        dft = [
          ...dft,
          {
            field: "flowExpireTime",
            hasEmpty: false,
            method: "lt",
            type: "datetime",
            value: [d],
          },
        ];
        break;
      }

      case "startAction": {
        dft = [
          ...dft,
          {
            field: "startAction",
            hasEmpty: false,
            method: "eq",
            type: "startAction",
            value: ["back"],
          },
        ];
        break;
      }
      case "lastAction": {
        dft = [
          ...dft,
          {
            field: "lastAction",
            hasEmpty: false,
            method: "eq",
            type: "lastAction",
            value: ["save"],
          },
        ];
        break;
      }
      case "isread1": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: true,
            method: "eq",
            value: [1],
          },
        ];
        break;
      }
      case "isread0": {
        dft = [
          ...dft,
          {
            field: "isread",
            type: "isread",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "inProcess": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "eq",
            value: [0],
          },
        ];
        break;
      }
      case "done": {
        dft = [
          ...dft,
          {
            field: "queryState",
            type: "queryState",
            hasEmpty: false,
            method: "in",
            value: [1, 2],
          },
        ];
        break;
      }
      default: {
        break;
      }
    }
    let dd = localStorage.getItem("BsyDashboardFlowCenterSort");
    let sort = dd ? dd : -1;
    let abb = {
      appId: this.appId ? this.appId : type,
      entryId: this.entryId ? this.entryId : undefined,
      formId: this.entryId ? this.entryId : undefined,
      ignoreAppId: this.appId ? undefined : true,
      hascount: true,
      limit: 20,
      mode: mode,
      corpId: corpId,
      skip: 0,
      sort: { updateTime: Number(sort) },
      keyword: keyword ? keyword : undefined,
      type: type,
      filter: BsyUtils.isObjectEmpty(dft)
        ? undefined
        : {
          cond: [...dft],
          rel: "and",
        },
    };
    let url = "/dashboard/flow_todo";
    if (this.appId) {
      url = `/dashboard/app/${this.appId}/workflow/query_data`;
    }

    switch (this.state.type) {
      case "todo": {
        React.axios(url, {
          ...abb,
        }).then((res0) => {
          this.setState({
            filterCount: res0.data.count,
          });
        });
        break;
      }
      case "cc": {
        React.axios(url, {
          ...abb,
        }).then((res0) => {
          this.setState({
            filterCount: res0.data.count,
          });
        });
        break;
      }
      default:
        React.axios(url, {
          ...abb,
        }).then((res0) => {
          this.setState({
            filterCount: res0.data.count,
          });
        });
    }
  };

  // 快捷处理事件
  onFlowItemQuickEvent = (item, type) => {
    let that = this;
    console.log(item, type);
    if (this.loading) {
      console.log("请求执行中");
      return;
    }
    that.loading = true;
    const submit = (ext) => {
      let layerRef = null;
      BsyMaskLayer({
        customCls: "sloading",
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <div>
              <BsySLoading />{" "}
            </div>
          );
        },
      });
      React.axios("/data/update", {
        appId: item.appId,
        entryId: item.entryId,
        formId: item.formId || item.entryId,
        dataId: item._id,
        flowId: item.flowId,
        flowType: "todo",
        flowAction: type,
        ...ext,
      })
        .then((res) => {
          layerRef && layerRef.close();
          that.loading = false;
          BsyUtils.showAjaxTip(
            res.data,
            () => {
              that._close();
            },
            () => {
              that._close();
            }
          );
        })
        .catch(() => {
          layerRef && layerRef.close();
          that.loading = false;
        });
    };

    switch (type) {
      case "back": {
        _switchBackNode(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          (res) => {
            submit({ backnode: res });
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }
      case "sign": {
        // todo 等后端返回 allowSignTypes
        _submitSign(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          item.allowSignTypes || [],
          (res) => {
            submit(res);
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }
      case "transfer": {
        // todo 等后端返回 candidates
        _switchTransferChargers(
          {
            limit: item.candidates ? item.candidates.limit : {},
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          (res) => {
            submit({ candidateId: res });
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }

      case "forward":
        _switchSubmit(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
            flowType: "todo",
          },
          (res) => {
            submit(res);
          }
        );
        break;
      default:
        submit();
    }
  };

  createItem = (item) => {
    const { type } = this.state;
    this._formatItem(item);

    var bg = BsyUtils.formatUserThumb(item.creatorName);
    const url = this.avatarMap[item.creator]
      ? this.avatarMap[item.creator]
      : "/template/bbymember/images/avatar_default.jpg";
    let c = "";
    BsyUtils.isArray(item.states) && (c = item.states.join("，"));
    let m = window.FX.CONST.FLOW_FAIL_HINT[item.flowFailureAction];
    let s = item.creatorName
      ? item.creatorName
      : React.language("widget.user.anonymous");
    let ct = dayjsUtils.timeToTZ(item.updateTime).getTime() - dayjsUtils.timeToTZ(new Date()).getTime();
    let ceftd = "";
    let cefth = "";
    let ceftm = "";
    let cefts = "";
    ct = Math.abs(ct);
    ceftd = Math.floor(ct / (1000 * 60 * 60 * 24)); //计算天数
    cefth = Math.floor((ct / (1000 * 60 * 60)) % 24); //计算小时数
    ceftm = Math.floor((ct / (1000 * 60)) % 60); //计算分钟数
    cefts = Math.floor((ct / 1000) % 60); //计算秒数
    if (ceftd !== 0 && cefth === 0 && ceftm === 0) {
      ct = React.language("waiting.new") + ceftd + React.language("days");
    } else if (ceftd === 0 && cefth !== 0 && ceftm === 0) {
      ct = React.language("waiting.new") + cefth + React.language("to.hour");
    } else if (ceftd === 0 && cefth === 0 && ceftm !== 0) {
      ct = React.language("waiting.new") + ceftm + React.language("to.minute");
    } else {
      ct =
        React.language("waiting.new") +
        ceftd +
        React.language("days") +
        cefth +
        React.language("to.hour") +
        ceftm +
        React.language("to.minute");
    }
    let v = "";
    let F = "";
    let g = null;
    if (item.flowExpireTime) {
      g = BsyUtils.getDateInfoFromNow(item.flowExpireTime);
      v = g.isLater ? "" : "overtime";
      F = "";
      if (g.isJustNow) {
        F = React.language("flow.list.date.just");
      } else {
        if (g.day >= 30) {
          F = React.language("flow.list.date.longAgo");
        } else {
          if (g.day) {
            F += g.day + React.language("days");
          } else {
            F += "";
          }
          if (g.hour) {
            F += g.hour + React.language("to.hour");
          } else {
            F += "";
          }
          if (!(v && F)) {
            if (g.minute) {
              F += g.minute + React.language("to.minute");
            } else {
              F += "";
            }
          }
        }
      }
      if (item.isUrged) {
        v = "overtime";
        F = g.isLater ? F : React.language("has.timed.out") + F;
      }
    }
    return (
      <li
        key={`${item._id}_${item.flowId}`}
        className={
          "flow-item line-item " + type + this.setCCItemUnreadStyle(item)
        }
        onClick={() => {
          this._editData({
            ...item,
            dataId: item._id,
            flowType: this.state.type,
          });
        }}
      >
        <div className="line-item-header">
          <div className="left">
            <div className="entry-name" title={item.entryName}>
              {this.highlighterText(item.entryName)}
            </div>
            {item.flowState == 0 ? (
              <div
                className="flow-charge-1"
                onMouseEnter={(e) => {
                  if (item.flowName) {
                    this.showTooltip(
                      e.currentTarget,
                      item.states.join("、"),
                      "top",
                      0
                    );
                  }
                }}
                onMouseLeave={this.hideTooltip}
              >
                <span className="current-node">
                  <i className="icon-subflow"></i>
                  {this.highlighterText(item.states.join("、"))}
                </span>
              </div>
            ) : (
              ""
            )}
            {this.renderUrgedStatus(item.isUrged)}
            {this.renderFlowSourceStatus(ct, item)}
            {item.flowState != 1 && item.flowState != 2 && type != "todo" ? (
              <>
                {item.chargersStr ? (
                  <div
                    className="flow-charge-1 charge"
                    onMouseEnter={(e) => {
                      if (item.chargersStr) {
                        this.showTooltip(
                          e.currentTarget,
                          item.chargersStr,
                          "top",
                          0
                        );
                      }
                    }}
                    onMouseLeave={this.hideTooltip}
                  >
                    {" "}
                    {this.highlighterText(item.chargersStr)}{" "}
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
          <div className="right">
            {["todo", "cc"].indexOf(type) == -1 ? (
              item.flowState === 0 ? (
                <div className="bsy-flow-state  in-process">
                  {React.language("flow.state.inProcess")}
                </div>
              ) : item.flowState === 1 ? (
                <div className="bsy-flow-state  complete">
                  {React.language("flow.node.end")}
                </div>
              ) : (
                <div className="bsy-flow-state  closed">
                  {React.language("flow.state.closed")}
                </div>
              )
            ) : (
              ""
            )}

            <div
              className="flow-time"
              onMouseEnter={(event) => {
                var tipText =
                  "create" === type
                    ? React.language("flow.time.start")
                    : "transactors" === type
                      ? React.language("flow.my.transactors.time")
                      : "cc" === type
                        ? React.language("flow.my.cc.time")
                        : "";
                if (!tipText) {
                  return;
                }

                window.FX.UI.showPopover({
                  position: "bottomLeft",
                  anchor: window.$(event.target),
                  content: window.$("<span/>").text(tipText),
                  type: "dark",
                });
              }}
              onMouseLeave={() => {
                window.FX.UI.closePopover();
              }}
            >
              {
                //var f = "create" === i.listType ? t.createTime : t.updateTime
                "create" === type
                  ? this.highlighterText(item.createTime)
                  : this.highlighterText(item.updateTime)
              }
            </div>
            {type === "todo" &&
              item.flowFailureAction &&
              (m ? (
                <div
                  className={
                    "flow-hint fail-hint " + (item.isUrged ? " overtime" : "")
                  }
                >
                  {m}
                </div>
              ) : item.flowExpireTime ? (
                <div className={"flow-hint expire-time-hint " + v}>
                  <i className="time-icon icon-alarm-o" />
                  {F}
                </div>
              ) : (
                ""
              ))}
            {"todo" === type &&
              !item.flowFailureAction &&
              (item.flowExpireTime ? (
                <div className={"flow-hint expire-time-hint " + v}>
                  <i className="time-icon icon-alarm-o" />
                  {F}
                </div>
              ) : (
                ""
              ))}
          </div>
        </div>
        <div className="line-item-content">
          {
            // item.isUrged && <div className="todoIsUrged">催</div>
          }
          {
            <>
              <div className="creator-info">
                {url.indexOf("://") > -1 ? (
                  <img className="headPortrait" srcSet={url} alt=""></img>
                ) : (
                  <>
                    <div className={"user-portrait-name color-" + bg.color}>
                      {this.highlighterText(bg.name)}
                    </div>{" "}
                    <div className="box-shaw">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </>
                )}
              </div>
              <div className="creator-name">
                <div className="name">{this.highlighterText(s)}</div>
              </div>
            </>
          }
          {/* <div className="state-info  ">
                    <div className="entry-name" title={item.entryName}>{this.highlighterText(item.entryName)}</div>
                    <div className="flow-charge">

                        <span className={type === 'todo' ? 'current-node' : 'nodes'}>
                            {c ? <>{<i className="icon-bsy-subform-flow" />}{this.highlighterText(c)}</> : ''}
                        </span>
                    </div>
                </div> */}

          {/* {
                    ["todo", 'cc'].indexOf(type) == -1 ?
                        item.flowState === 0 ?
                            <div className="flow-state in-process">{React.language('flow.state.inProcess')}</div> : item.flowState === 1 ?
                                <div className="flow-state complete">{React.language('flow.node.end')}</div> :
                                <div className="flow-state closed">{React.language('flow.state.closed')}</div> : ''


                } */}
          <div className="flow-brief-list">
            <ul
              className={
                "flow-brief " + (item.data.length > 3 ? "brief-more" : "")
              }
            >
              {item.data &&
                item.data.map((dd, index) => {
                  if (index >= 3) {
                    return "";
                  }
                  return dd.label ? (
                    <li className="brief-item">
                      <span className="brief-label">{dd.label}</span>
                      <span className="brief-val">
                        <span className="sep">：</span>
                        {this.highlighterText(this._formatData(dd))}
                      </span>
                    </li>
                  ) : (
                    ""
                  );
                })}
            </ul>
            {item.data.length > 3 ? (
              <ul
                className={
                  "flow-brief " + (item.data.length > 3 ? "brief-more" : "")
                }
              >
                {item.data &&
                  item.data.map((dd, index) => {
                    if (index < 3) {
                      return "";
                    }
                    return dd.label ? (
                      <li className="brief-item">
                        <span className="brief-label">{dd.label}</span>
                        <span className="brief-val">
                          <span className="sep">：</span>
                          {this.highlighterText(this._formatData(dd))}
                        </span>
                      </li>
                    ) : (
                      ""
                    );
                  })}
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
        {type === "todo"
          ? generateQuickBtn(item, (type) => {
            this.onFlowItemQuickEvent(item, type);
          })
          : ""}
      </li>
    );
  };
  _formatItem = (a) => {
    const { title } = this.state;
    var b = this;

    if ("todo" === title) {
      a.creatorName = BsyUtils.isNull(a.creator)
        ? React.language("widget.user.anonymous")
        : BsyUtils._toDeptUser(this.nameMap[a.creator]);
      a.updateTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.updateTime),
        "yyyy-MM-dd HH:mm:ss"
      );
      a.createTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.createTime),
        "yyyy-MM-dd HH:mm:ss"
      );
    } else {
      var d = [];
      BsyUtils.forEach(a.chargers, function (a, c) {
        d.push(BsyUtils._toDeptUser(b.nameMap[c]));
      });
      a.chargersStr = d.join(",");
      a.creatorName = BsyUtils.isNull(a.creator)
        ? React.language("widget.user.anonymous")
        : BsyUtils._toDeptUser(this.nameMap[a.creator]);
      a.updateTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.updateTime),
        "yyyy-MM-dd HH:mm:ss"
      );
      a.createTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.createTime),
        "yyyy-MM-dd HH:mm:ss"
      );
    }
    if (a.updateTime)
      a.updateTime =
        BsyUtils.isString(a.updateTime) && a.updateTime.indexOf("T") === -1
          ? a.updateTime.replace(/-/g, "/")
          : a.updateTime;
    if (a.createTime)
      a.createTime =
        BsyUtils.isString(a.createTime) && a.createTime.indexOf("T") === -1
          ? a.createTime.replace(/-/g, "/")
          : a.createTime;
  };
  _editData = (b) => {
    const { type } = this.state;

    let that = this;
    const { restore } = BsyUtils.globalIdManager(b.appId, b.entryId, b._id);
    let layerRef = null;

    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("fadein-right")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            {...b}
            mode={"edit"}
            loading={false}
            flowType={type || b.entryId}
            onSuccess={() => {
              restore();
              if (type === "launch") {
                // this.loadData(null, false);
                // this.loadTodoCount()
                // if (this.state.type == 'cc') {
                that.queryCcUnread();
              } else {
                that._close();
              }
              layerRef && layerRef.close();
            }}
            onClose={() => {
              restore();
              if (type === "cc") {
                that._close();
              }
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  _loadEntry = (b) => {
    var c = this;

    React.axios("/dashboard/app/" + b.appId + "/entry/" + b.entryId, {
      authGroupId: 1,
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let b = res.data;
          window.FX.Vip.showUpgradeTip(b.bufferState);
          let e = window
            .$('<div class="x-window-mask modal light"/>')
            .css({
              "z-index": window.FX.STATIC.zIndex++,
            })
            .appendTo("body");

          let f = b.entry;
          window.FX.STATIC.IS_EVENT = b.isEvent === true;
          window.FX.STATIC.APPID = f.appId;
          window.FX.STATIC.ENTRYID = f.entryId;
          new window.FX.Form(
            window.$.extend(f.content, {
              renderEl: window
                .$('<div className="flow-form x-shadow-content"/>')
                .appendTo(e),
              appId: f.appId,
              entryId: f.entryId,
              title: f.name,
              multiTabs: f.formTabs,
              formTabsStyle: f.formTabsStyle || {},
              width: 1080,
              height: "100%",
              authGroupId: -1,
              submitText: React.language("submit"),
              cancelText: f.hasFlowPrint ? null : React.language("cancel"),
              printText: f.hasFlowPrint
                ? React.language("flow.action.print")
                : null,
              // buttonPosition: "middle",
              version: b.version,
              onSuccess: function (a, b, d) {
                d && c._showFormPrint(a.data);
                tipAlert({
                  type: "success",
                  msg: React.language("submit.success"),
                });
                e.remove();

                window.FX.STATIC.IS_EVENT = false;
                window.FX.STATIC.APPID = null;
                window.FX.STATIC.ENTRYID = null;

                //--------发起流程后,刷新一下待办任务--------
                c.loadTodoCount();
                //--------发起流程后,刷新一下待办任务--------
              },
              onAfterCancel: function () {
                this.saveFormData();
                e.remove();
                window.FX.STATIC.IS_EVENT = false;
                window.FX.STATIC.APPID = null;
                window.FX.STATIC.ENTRYID = null;
              },
            })
          );
          // )
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  _showFormPrint = (b) => {
    var c = window.FX.Utils.createLoadLayer(window.$("body"), {
      isLight: !0,
      isModal: !0,
    });
    new window.FX.FormEditPane({
      renderEl: window.$('<div className="x-shadow-content"/>').appendTo(c),
      width: 1080,
      height: "100%",
      originPrint: "flow",
      dataId: b._id,
      entryId: b.entryId,
      appId: b.appId,
      flowType: "print",
      flowId: 0,
      hasFlowBtn: !1,
      onCancel: function () {
        c.remove();
      },
    });
  };

  _close = () => {
    if (this.state.type) {
      this.setState(
        {
          page: 0,
          items: [],
          isMore: false,
        },
        () => {
          // this.loadData();
          this.loadData(null, false);
          this.loadTodoCount();
          // if (this.state.type == 'cc') {
          this.queryCcUnread();
          // }
        }
      );
    }

    // this.$mask.remove()
    // this.$mask = null;
    // this.form = null;
  };

  renderFlowList = () => {
    const { items } = this.state;

    return (
      <>
        {items.map((data) => {
          return this.createItem(data);
        })}
      </>
    );
  };

  renderAppFlowLaunch = (appdata, appIndex) => {
    return (
      <ul className="flow-entry-list">
        {appdata.data.map((data) => {
          return (
            <li
              className="entry-item"
              onClick={() => {
                this._editData({ ...data, dataId: data._id });
              }}
            >
              <div className="entry-name">
                <div
                  className={"border color-flow-launch-" + (appIndex % 4)}
                  title={data.name}
                >
                  {data.name}
                </div>
              </div>
              <div className="entry-bottom">
                <div className="entry-launch">
                  <span>{React.language("flow.launch")}</span>
                  <i className="icon-angleright"></i>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  //发起流程面板
  renderFlowLaunch = () => {
    const { items } = this.state;

    return (
      <>
        {items.map((data, index) => {
          return (
            <li className="app-item">
              <div className="app-title">{data.name}</div>
              {this.renderAppFlowLaunch(data, index)}
            </li>
          );
        })}
      </>
    );
  };

  onScroll = (e) => {
    const { isMore, page } = this.state;

    if (isMore) {
      if (this.flowlistRef && this.flowlistRef.current) {
        if (
          this.flowlistRef.current.offsetHeight <=
          e.target.scrollTop + e.target.offsetHeight
        ) {
          this.setState(
            {
              isMore: false,
              page: page + 1,
            },
            () => {
              this.loadData("more");
            }
          );
        }
      }
    }
  };

  readAll = () => {
    const { items } = this.state;

    let data = {
      list: [],
    };
    BsyUtils.forEach(items, (index, item) => {
      data.list.push({
        appId: item.appId,
        entryId: item.entryId,
        _id: item._id,
      });
    });
    if (data.list.length == 0) {
      return;
    }

    React.axios("/data/flow_set_read", {
      ...data,
    })
      .then(() => {
        this.loadData();
      })
      .catch(() => { });
  };

  subMenuRefresh = (filterType) => {
    this.setState(
      {
        filterType: filterType,
        page: 0,
        items: [],
        isMore: false,
      },
      () => {
        this.loadData();
        if (filterType === "all") {
          this.loadFilterCount();
          this.loadTodoCount();
        }
        if (this.state.type === "cc") {
          this.queryCcUnread();
        }
      }
    );
  };

  refresh = (sort) => {
    let dd = localStorage.getItem("BsyDashboardFlowCenterSort");
    let s = dd ? dd : -1;
    this.setState(
      {
        page: 0,
        sort: !sort ? Number(s) : sort,
        items: [],
        isMore: false,
      },
      () => {
        if (this.state.type !== "launch") {
          this.loadData(null, false);
          this.loadTodoCount();
        } else {
          this.loadFlowStart();
        }
        this.queryCcUnread();
      }
    );
  };

  sortRefresh = (e) => {
    const { sort, type } = this.state;
    let menu = [
      {
        text: React.language("platform.flow." + type + ".latest"),
        colorType: sort === -1 ? "selected" : "",
        icon: sort === -1 ? "icon-ok" : "",
        click: () => {
          localStorage.setItem("BsyDashboardFlowCenterSort", -1);
          this.refresh(-1);
        },
      },
      {
        text: React.language("platform.flow." + type + ".earliest"),
        colorType: sort === 1 ? "selected" : "",
        icon: sort === 1 ? "icon-ok" : "",
        click: () => {
          localStorage.setItem("BsyDashboardFlowCenterSort", 1);
          this.refresh(1);
        },
      },
    ];

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: e.currentTarget,
      theme: "flow-sort",
    });
  };

  filterTitle = () => {
    const { filterType, allcount, filterCount, keyword, query_cc_unread } =
      this.state;

    // this.props.flowType == 'todo'
    switch (this.state.type) {
      case "todo": {
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (filterType === "all" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("all");
              }}
            >
              <span>{React.language("all")}</span>
              {allcount > 0 && (
                <span className="num">
                  {"(" +
                    (this.appId || keyword
                      ? filterCount != undefined
                        ? filterCount + "/"
                        : ""
                      : "") +
                    (allcount ? allcount : 0) +
                    ")"}
                </span>
              )}
            </div>
            <div
              className={
                "todoMenu-item " + (filterType === "urge" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("urge");
              }}
            >
              <span>{React.language("flow.Urge")}</span>
            </div>
            <div
              className={
                "todoMenu-item " +
                (filterType === "flowExpireTime" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("flowExpireTime");
              }}
            >
              <span>{React.language("about.to.time.out")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (filterType === "timeout" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("timeout");
              }}
            >
              <span>{React.language("timeout")}</span>
            </div>

            <div
              className={
                "todoMenu-item " +
                (filterType === "startAction" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("startAction");
              }}
            >
              <span>{React.language("flow.action.back")}</span>
            </div>

            <div
              className={
                "todoMenu-item " +
                (filterType === "lastAction" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("lastAction");
              }}
            >
              <span>{React.language("flow.action.save")}</span>
            </div>
          </div>
        );
      }
      case "cc": {
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (filterType === "all" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("all");
              }}
            >
              <span>{React.language("all")}</span>
              {allcount > 0 && (
                <span className="num">
                  {"(" +
                    (this.appId || keyword
                      ? filterCount != undefined
                        ? filterCount + "/"
                        : ""
                      : "") +
                    (allcount ? allcount : 0) +
                    ")"}
                </span>
              )}
            </div>
            <div
              className={
                "todoMenu-item " +
                (query_cc_unread ? " unread " : "") +
                (filterType === "isread0" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("isread0");
              }}
            >
              <span>{React.language("unread")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (filterType === "isread1" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("isread1");
              }}
            >
              <span>{React.language("read")}</span>
            </div>
          </div>
        );
      }

      default:
        return (
          <div className="todoFlowFilter">
            <div
              className={
                "todoMenu-item " + (filterType === "all" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("all");
              }}
            >
              <span>{React.language("all")}</span>
              {allcount > 0 && (
                <span className="num">
                  {"(" +
                    (this.appId || keyword
                      ? filterCount != undefined
                        ? filterCount + "/"
                        : ""
                      : "") +
                    (allcount ? allcount : 0) +
                    ")"}
                </span>
              )}
            </div>
            <div
              className={
                "todoMenu-item " +
                (filterType === "inProcess" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("inProcess");
              }}
            >
              <span>{React.language("flow.state.inProcess")}</span>
            </div>
            <div
              className={
                "todoMenu-item " + (filterType === "done" ? "selected" : "")
              }
              onClick={() => {
                this.subMenuRefresh("done");
              }}
            >
              <span>{React.language("doned")}</span>
            </div>
          </div>
        );
    }
  };

  highlighterText = (text, color) => {
    const { keyword } = this.state;

    return BsyUtils.highlighterText(keyword, text, color);
  };

  renderUrgedStatus = (isUrged) => {
    if (!isUrged) {
      return "";
    }
    return <div className="todoIsUrged">{React.language("flow.Urge.one")}</div>;
  };

  renderFlowSourceStatus = (ct, res) => {
    const { entryId } = this.state;

    //  'save' => '暂存'
    //  'back' => '回退'
    // 'revoke' => '撤回'
    // 'activate' => '激活',
    // 'transfer' => '转交',

    let types = [
      "save",
      "back",
      "revoke",
      "activate",
      "transfer",
      "sign",
      "sign_before",
      "sign_after",
      "sign_parallel",
    ];

    if (
      (!res.startAction && !res.lastAction) ||
      (!types.includes(res.startAction) && !types.includes(res.lastAction))
    ) {
      return (
        <>
          {res.backflowid != 0 && (
            <div className="infoBack">
              {React.language("form.backflowidName", {
                name: res.backflowidName,
              })}
            </div>
          )}

          {entryId === "todo" && res.backflowid == 0 && (
            <div className="waitedTime">{ct}</div>
          )}
        </>
      );
    }

    //React.language("form.backflowidName", { name: res.backflowidName })

    if (res.startAction === res.lastAction) {
      res.lastAction = "";
    }

    return (
      <div className="source-status">
        {types.includes(res.startAction) ? (
          <div
            className={"status-item " + res.startAction}
            title={
              res.startAction === "back"
                ? React.language("form.backflowidName.title", {
                  name: res.backflowidName,
                }) + React.language("form.backflowidName.end")
                : ""
            }
          >
            {res.startAction === "back" ? (
              <>
                <div className="name-title">
                  {React.language("form.backflowidName.title", {
                    name: res.backflowidName,
                  })}
                </div>
                <div className="name-end">
                  {React.language("form.backflowidName.end")}
                </div>
              </>
            ) : (
              React.language("flow.action." + res.startAction)
            )}
          </div>
        ) : (
          ""
        )}
        {types.includes(res.lastAction) ? (
          <div
            className={"status-item " + res.lastAction}
            title={
              res.startAction === "back"
                ? React.language("form.backflowidName.title", {
                  name: res.backflowidName,
                }) + React.language("form.backflowidName.end")
                : ""
            }
          >
            {res.lastAction === "back" ? (
              <>
                <div className="name-title">
                  {React.language("form.backflowidName.title", {
                    name: res.backflowidName,
                  })}
                </div>
                <div className="name-end">
                  {React.language("form.backflowidName.end")}
                </div>
              </>
            ) : (
              React.language("flow.action." + res.lastAction)
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  onGetFilterPaneContext = (context) => {
    this.filterPaneContext = context;
  };

  getFilterCacheKey = () => {
    return BsyUtils.Store.getKey("flowCenterFilter", {
      appId: this.state.type,
      //   appId: appId,
      //   entryId: entryId,
      //   authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : ''
    });
  };

  setFilterCache = (val) => {
    BsyUtils.Store.set(this.getFilterCacheKey(), val);
  };

  getFilterCache = () => {
    if (this.filter) return;
    let res = BsyUtils.Store.get(this.getFilterCacheKey());
    // console.log(res);
    if (res) {
      this.filter = res.cond ? [...res.cond] : [];
      this.appId = res.appId;
      this.entryId = res.entryId;
    }
  };

  getFilterConfig = () => {
    this.getFilterCache();
    return {
      hasRelation: false,
      hasPin: false,
      hasHeader: false,
      mode: this.state.mode,
      corpId: this.state.corpId,
      flowType: this.state.type,
      rel: "and",
      cond: this.filter || [],
      appId: BsyUtils.isObjectEmpty(this.appId) ? null : this.appId,
      entryId: BsyUtils.isObjectEmpty(this.entryId) ? null : this.entryId,
      hasAppField: true, //有app 字段
      entryList: {},

      onSetFieldFilter: (val) => {
        this.filter = [...val.cond];
        this.appId = val.appId;
        this.entryId = val.entryId;
      },
      onFilter: (val, clearFilter) => {
        if (clearFilter) {
          this.filter = [];
          this.appId = null;
          this.entryId = null;
        } else {
          this.filter = [
            ...val.cond,
            {
              field: "entryId",
              type: "flowentry",
              hasEmpty: false,
              method: "eq",
              value: [val.entryId],
            },
          ];
          this.appId = val.appId;
          this.entryId = val.entryId;
        }

        this.setFilterCache(val);
        this.setState(
          {
            page: 0,
            items: [],
            isMore: false,
            filter: this.filter,
          },
          () => {
            this.loadFilterCount();
            this.loadData();
          }
        );
      },
    };
  };

  reFilter = () => {
    this.filter = [];
    this.appId = null;
    this.entryId = null;

    this.setFilterCache({});
    this.setState({
      page: 0,
      items: [],
      isMore: false,
      filter: this.filter,
    });
  };

  onFilter = (e) => {
    let config = this.getFilterConfig();

    BsyMsgBubble({
      anchor: e.currentTarget,
      onGetContext: this.onGetFilterPaneContext,
      contentHTML: (ref) => {
        return (
          <BsyFilterPane
            {...config}
            hasSticky={!1}
            hasPin={false}
            context={ref}
          ></BsyFilterPane>
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: 350,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "right",
      onClose: function () {
        return !1;
      },
    });
  };

  switchFlowMenu2 = (v) => {
    this.setState({ mode: v }, () => {
      this.reFilter();
      this.refresh();
    });
  };

  onSwitchCorp = (v) => {
    this.setState({ corpId: v }, () => {
      this.reFilter();
      this.refresh();
    });
  };

  _initHideMenu = () => {
    this.body.current.classList.toggle("full-screen");
  };

  render() {
    const {
      type,
      query_cc_unread,
      sort,
      filterType,
      isLoading,
      seachSwitch,
      success,
      corpId,
      mode,
      isDock,
      todocount,
      dockcount,
      corp_count,
      default_corp,
      todoCount,
      isMoreLoading,
      title,
    } = this.state;
    setPageTitle(`${title} - ${React.language("flow.center")}`);
    return (
      <div
        className="bsy-dashboard-flow-center BsyDashboardApp "
        ref={this.elementRef}
      >
        <div className="bsy-dashboard-flow-center-content">
          <div className="bsy-frame-body" ref={this.body}>
            <div className="bsy-frame-menu" ref={this.menu}>
              <div
                className="bsy-sidebar-container"
                onClick={this._initHideMenu}
              >
                <div className="icon-container">
                  <i className={"bs-icon-iconcaidanshouqi"} />
                </div>
              </div>
              <div className="bsy-frame-to-app">
                <BsySystemLeftMenu
                  homeLink="/team"
                  backTitle={React.language("dashboard")}
                  onRenderTitle={() => (
                    <div className="left-title">
                      {React.language("flow.center")}
                    </div>
                  )}
                ></BsySystemLeftMenu>
              </div>

              <div className="bsy-frame-search">
                <div className={"bsy-flow-menu "}>
                  {this.FlowMenuData.map((val) => {
                    return (
                      <>
                        {val.id === "launch" && <div className="line"></div>}
                        <div
                          key={`bsy-flow-menu-${val.id}`}
                          id={"menu" + val.id}
                          className={
                            "menu-item " +
                            val.id +
                            (val.id === type ? " select " : "") +
                            (val.id === "cc" &&
                              (query_cc_unread ? " unread " : ""))
                          }
                          onClick={() => {
                            this.switchFlowMenu(val);
                          }}
                        >
                          <i className={"icon-new-img-bby-visit-" + val.id} />
                          <span>{val.text}</span>
                          {val.id === "todo" && todoCount !== 0 && (
                            <span
                              className="tip flow-count error"
                              ref={this.flownumref}
                              title={React.language("flow.todo.count", {
                                count: todoCount,
                              })}
                            >
                              {todoCount}
                            </span>
                          )}
                          {val.id === "cc" && query_cc_unread ? (
                            <span className="tip min error"> </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="bsy-frame-content">
              {
                <div className="bsy-content flow">
                  <div className="bsy-frame-path-container">
                    {dockcount > 0 ? (
                      <FlowSwitchMenu
                        todocount={todocount}
                        dockcount={dockcount}
                        corp_count={corp_count}
                        default_corp={default_corp}
                        flowActive={!!isDock ? "externalFlow" : "internalFlow"}
                        switchFlowMenu={this.switchFlowMenu2}
                        onSwitchCorp={this.onSwitchCorp}
                        dockCorp={this.state.dockCorp}
                        corpId={corpId}
                        mode={mode}
                      />
                    ) : (
                      <div></div>
                    )}

                    <BsySystemRightMenu search={false} />
                  </div>

                  <div className="bsy-frame-entry-content">
                    <div className="BsyDashboardFlowFilter">
                      <div
                        className={
                          "flowFilterHeader  " +
                          this.state.type +
                          " " +
                          this.state.filterType
                        }
                      >
                        <div className="filterTitle">
                          <div className="breadcrumb"></div>

                          {type !== "launch" ? (
                            this.filterTitle()
                          ) : (
                            <div className="entry-name flow">
                              <div className="form-name">
                                {React.language("flow.create")}
                              </div>
                            </div>
                          )}
                        </div>
                        {type !== "launch" ? (
                          <div className="filter-header-right">
                            {seachSwitch ? (
                              <BsySearchInput
                                placeholder={React.language("search.flow")}
                                styleInput={{
                                  width: "200px",
                                }}
                                onSearch={(val) => {
                                  this.setState(
                                    {
                                      keyword: val,
                                      page: 0,
                                      items: [],
                                      isMore: false,
                                    },
                                    () => {
                                      this.loadData();
                                      this.loadFilterCount();
                                    }
                                  );
                                }}
                                type={window.mode}
                              // iconName="icon-bsy-reportmenu-0"
                              ></BsySearchInput>
                            ) : (
                              ""
                            )}

                            <div
                              className="menu-sort right-item"
                              onClick={this.sortRefresh}
                            >
                              <i className="icon-bby-iconpaixu" />
                              <span>
                                {sort === -1
                                  ? React.language("latest")
                                  : React.language("earliest")}
                              </span>
                            </div>

                            <div
                              className={`menu-filter right-item ${this.appId ? "selected" : ""
                                }`}
                              onClick={this.onFilter}
                            >
                              <i className="icon-bsy-shaixuananniu" />
                              <span>{React.language("filter")}</span>
                            </div>

                            <div
                              className="menu-refresh right-item"
                              onClick={() => {
                                this.refresh();
                              }}
                            >
                              <i className="icon-async" />
                              <span>{React.language("refresh")}</span>
                            </div>

                            {filterType === "isread0" ? (
                              <div
                                className="menu-readAll right-item"
                                onClick={() => {
                                  this.readAll();
                                }}
                              >
                                <i className="icon-bsy-cc-read" />
                                {React.language("msg.readAll")}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {success && (
                      <div
                        className="bsy-flow-list-container"
                        onScroll={this.onScroll}
                      >
                        {type !== "launch" ? (
                          <>
                            <div
                              className=" bsy-flow-list"
                              ref={this.flowlistRef}
                            >
                              <ul className="flow-list">
                                {this.renderFlowList()}
                              </ul>
                            </div>
                            {isMoreLoading ? (
                              <div className="loading">
                                {React.language("loading")}
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <div className="flow-pane app-visit fx_flow_launch">
                            <ul className="flow-app-list">
                              {this.renderFlowLaunch()}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                    {isLoading ? <BsySLoading></BsySLoading> : ""}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BsyDashboardFlowCenter);
